const TOUR_DIALOG_TYPE = 'TourDialog';
const TABS_COMPONENT_TYPE = 'Tabs';
const LAYOUT_COMPONENT_TYPE = 'Layout';
const SWIPEABLE_TABS_TYPE = 'SwipeableTabs';
const TABLE_PANEL_TYPE = 'TablePanel';
const CARD_LIST_TYPE = 'CardList';
const GRAPH_DASHBOARD_TYPE = 'GraphDashboard';

export {
  TOUR_DIALOG_TYPE,
  TABS_COMPONENT_TYPE,
  LAYOUT_COMPONENT_TYPE,
  SWIPEABLE_TABS_TYPE,
  TABLE_PANEL_TYPE,
  CARD_LIST_TYPE,
  GRAPH_DASHBOARD_TYPE,
};
